import React from 'react'
import { EditorialType } from '../../templates/Publication/lib/get-editorial-type'
import { useProduct } from '../../__product/useProduct'
import { colors } from '../../__styling/settings/colors'
import { perthNowSectionDefinitions } from '../../__styling/settings/sections/perthnow'
import {
    StyledEditorialLabel,
    StyledEditorialLabelText,
    StyledIconLightning,
    StyledLiveBubble,
    StyledPerthNowBlock,
    StyledPerthNowIcon,
    StyledTheWestMark,
} from './EditorialLabel.styled'

export interface EditorialLabelProps {
    className?: string
    type: EditorialType
    cardHasBackground?: boolean
    isLarge?: boolean
}

interface LabelIconProps {
    type: EditorialType
    isLarge?: boolean
}

const LabelIcon: React.FC<LabelIconProps> = ({ type, isLarge }) => {
    const product = useProduct()

    switch (type) {
        case EditorialType.Analysis:
        case EditorialType.Replay:
        case EditorialType.Investigation:
        case EditorialType.Upcoming:
        case EditorialType.Opinion:
        case EditorialType.Review:
            return product === 'perthnow' ? (
                <StyledPerthNowBlock isLarge={isLarge} />
            ) : null
        case EditorialType.Exclusive:
            return product === 'perthnow' ? (
                <StyledPerthNowIcon isLarge={isLarge} />
            ) : (
                <StyledTheWestMark
                    isLarge={isLarge}
                    fill={colors.thewest.westblue}
                />
            )
        case EditorialType.Live:
            return <StyledLiveBubble />
        case EditorialType.Breaking:
            return (
                <StyledIconLightning
                    isLarge={isLarge}
                    fill={
                        product === 'perthnow'
                            ? perthNowSectionDefinitions.default.primaryColor
                            : colors.thewest.ladybird
                    }
                />
            )
    }
}

export const EditorialLabel: React.FC<EditorialLabelProps> = ({
    className,
    type,
    cardHasBackground,
    isLarge,
}) => {
    const product = useProduct()

    if (product === 'sevennews' && type !== EditorialType.Live) {
        return null
    }

    const isBreaking = type === EditorialType.Breaking

    return (
        <StyledEditorialLabel
            className={className}
            isBreaking={isBreaking}
            cardHasBackground={cardHasBackground}
            isLarge={isLarge}
        >
            <LabelIcon type={type} isLarge={isLarge} />{' '}
            <StyledEditorialLabelText>{type}</StyledEditorialLabelText>
        </StyledEditorialLabel>
    )
}
EditorialLabel.displayName = 'EditorialLabel'
